// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"dda11a55","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};